import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AiPrompt } from 'app/Model/aiprompt';
import { AiPromptsService } from 'app/Services/aiprompt.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { LoadOptions } from 'devextreme/data';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { lastValueFrom } from 'rxjs';
import { Customer } from '../../../Model/User/Customer';
import { TemplateService } from '../../../Services/template.service';
import { Message } from '../../../Model/System/Message';

@Component({
    selector: 'app-aiprompt-list',
    templateUrl: './aiprompt-list.component.html',
    standalone: false
})
export class AipromptListComponent implements OnInit {
  @ViewChild('grid', { static: false }) grid!: DxDataGridComponent;
  promtps: AiPrompt[] = [];
  editedPrompt: AiPrompt = null;
  dataSource: DataSource;
  customers: Customer[];
  selectedCustomers: string[];
  isSelectCustomerVisible: boolean = false;
  templateIdToCopy: string;
  hasCustomersList: boolean = false;
  constructor(
    public loginService: LoginService,
    public translate: TranslateService,
    public systemService: SystemService,
    public promptService: AiPromptsService

  ) {
    
    let that = this;
    this.dataSource = new DataSource({
      store: new CustomStore({
        key: "id",
        load: async function (loadOptions: any) {
          return await that.promptService.getAll(that.loginService.currentCustomer.id);
        },
        insert: async function (values) {
          let newUser: AiPrompt = values as AiPrompt;
          newUser.id = "";
          return await that.promptService.create(newUser, that.loginService.currentCustomer.id);
        },
        update: async function (key, values) {
          let userToUpdate = await that.promptService.create(key, that.loginService.currentCustomer.id);
          Object.assign(userToUpdate, values);
          return await that.promptService.update(userToUpdate, that.loginService.currentCustomer.id);
        },
        remove: async function (key) {
          await that.promptService.delete(key, that.loginService.currentCustomer.id);
          return;
        }
      }
      ),
      reshapeOnPush: true,
    });
  }

  async ngOnInit() {
    this.loginService.customerService.getAllCustomerByUser(this.loginService.currentUser.id).subscribe((customers: Customer[]) => {
        this.customers = new Array<Customer>();
        customers.forEach((customer: Customer) => {
          if (customer.id != this.loginService.currentCustomer.id) {
            this.customers.push(customer);
          }
        });
        if(this.customers?.length > 0) {
          this.hasCustomersList = true;
          console.log(this.customers);
        }
      });

    
  }

  onInitNewRow(e) {
    e.data = new AiPrompt("Neuer Prompt");
    this.editedPrompt = e.data;
  }

  onEditingStart(e: DxDataGridTypes.EditingStartEvent<any, any>) {
    this.editedPrompt = e.data;   
    this.editedPrompt ??= new AiPrompt("Neuer Prompt");
  }

  onSaveEdit = async () => {
    if (!this.editedPrompt) return;
    try {
      await this.promptService.update(this.editedPrompt, this.loginService.currentCustomer.id);
      this.promtps = await this.promptService.getAll(this.loginService.currentCustomer.id);
      this.grid.instance.cancelEditData();
      this.grid.instance.refresh();
    } catch (err) {
      console.error(err);
    }
  };

  onCancelEdit = () => {
    this.grid.instance.cancelEditData();
  }

  
  duplicateAiPrompt =(event: any) =>{
    this.isSelectCustomerVisible = true;
    var promptToCopy: AiPrompt = event.row.data;
    this.templateIdToCopy = event.row.data.id; 
  }

  async copyTemplate(e) {
    
    let failureCustomerNames: string[] = [];
    this.isSelectCustomerVisible = false;

    for (const targetCustomerId of this.selectedCustomers) {

      try {
        const copySuccess = await this.promptService.copyPrompt(
          this.loginService.currentCustomer.id, 
          this.templateIdToCopy,               
          targetCustomerId                      
        );

        if (copySuccess) {
        }
        else {
         
          failureCustomerNames.push(targetCustomerId);
          }
      }
      catch (err) {
     
      }
      
    }
    if (failureCustomerNames.length != 0) {

      let returnString = "Prompt bereits vorhanden, nicht kopiert für: ";
       returnString +=  failureCustomerNames.join(",");
      this.systemService.notifyWarning(returnString);
    }

  }

  canCopy(): boolean {
    if (this.selectedCustomers?.length == 0) {
      return false;
    }
    return true;
  }

}
